<template>
  <div id="app">
    <div id="Notifications"></div>
    <router-view />
    <ActionModal />
    <ActionIframeDrawer />
  </div>
</template>

<script>
import ActionModal from "@/components/Base/ActionModal";
import ActionIframeDrawer from "@/components/Base/ActionIframeDrawer.vue";
export default {
  components: { ActionModal, ActionIframeDrawer },
  data() {
    return {
      internetStatus: {
        connection: false,
        speed: 10,
      },
    };
  },
  methods: {
    GET_LANG() {
      const lang = localStorage.getItem("lang");
      if (this.$i18n.availableLocales.includes(lang)) this.$i18n.locale = lang;
    },
    CONNECTION_INFORMATION_OF_INTERNET() {
      const vm = this;
      this.internetStatus.connection = window.navigator.onLine;
      window.addEventListener("offline", () => {
        vm.internetStatus.connection = false;
      });
      window.addEventListener("online", () => {
        vm.internetStatus.connection = true;
      });
    },
  },
  async created() {
    // dil bilgisi alınır.
    this.GET_LANG();
    // this.CONNECTION_INFORMATION_OF_INTERNET();
  },
};
</script>

<style></style>
